const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_PATTERN = /^[\d\s()+\-]{6,20}$/;

const ALLOWED_ACCOUNT_KINDS = new Set(['cfd', 'investment', 'saving']);
const ALLOWED_AMOUNTS = new Set(['Below 5k', '5k – 25k', '25k – 100k', 'Above 100k']);
const ALLOWED_EXPERIENCE = new Set(['0–1 years', '1–3 years', '3–5 years', '5+ years']);
const ALLOWED_YES_NO = new Set(['Yes', 'No']);

export const validateCreateAccountForm = (values) => {
  const errors = {};

  const setError = (field, message) => {
    if (!errors[field]) {
      errors[field] = message;
    }
  };

  if (!ALLOWED_ACCOUNT_KINDS.has(values.accountKind)) {
    setError('accountKind', 'Please choose a valid account type.');
  }

  if (!values.firstName?.trim()) {
    setError('firstName', 'First name is required.');
  }

  if (!values.lastName?.trim()) {
    setError('lastName', 'Last name is required.');
  }

  if (!values.email?.trim()) {
    setError('email', 'Email is required.');
  } else if (!EMAIL_PATTERN.test(values.email.trim())) {
    setError('email', 'Please enter a valid email address.');
  }

  if (!values.countryCode?.trim()) {
    setError('countryCode', 'Country code is required.');
  }

  if (!values.phone?.trim()) {
    setError('phone', 'Phone number is required.');
  } else if (!PHONE_PATTERN.test(values.phone.trim())) {
    setError('phone', 'Please enter a valid phone number.');
  }

  if (!values.address?.trim()) {
    setError('address', 'Address is required.');
  }

  if (!values.city?.trim()) {
    setError('city', 'City is required.');
  }

  if (!values.region?.trim()) {
    setError('region', 'State/Province/Region is required.');
  }

  if (!values.postalCode?.trim()) {
    setError('postalCode', 'ZIP/Postal code is required.');
  }

  if (!values.country?.trim()) {
    setError('country', 'Country is required.');
  }

  if (!values.passportFile) {
    setError('passport', 'Passport file is required.');
  }

  if (!values.amount || !ALLOWED_AMOUNTS.has(values.amount)) {
    setError('amount', 'Please select an investment amount.');
  }

  if (!values.experience || !ALLOWED_EXPERIENCE.has(values.experience)) {
    setError('experience', 'Please select your years of experience.');
  }

  if (!values.priorExperience || !ALLOWED_YES_NO.has(values.priorExperience)) {
    setError('priorExperience', 'Please answer this question.');
  }

  if (!values.consultation || !ALLOWED_YES_NO.has(values.consultation)) {
    setError('consultation', 'Please answer this question.');
  }

  if (!values.agreed) {
    setError('agreed', 'You must agree to the privacy policy.');
  }

  if (values.accountKind === 'cfd') {
    if (!values.cfdAccountType) {
      setError('cfdAccountType', 'Please select an account type.');
    }
    if (!values.leverage) {
      setError('leverage', 'Please select leverage.');
    }
  }

  if (values.accountKind === 'investment') {
    if (!values.investmentType) {
      setError('investmentType', 'Please select an investment type.');
    }
    if (!values.selectedProduct) {
      setError('selectedProduct', 'Please select a product.');
    }
  }

  if (values.accountKind === 'saving') {
    if (!values.savingAccountType) {
      setError('savingAccountType', 'Please select an account type.');
    }
  }

  const messages = Object.values(errors);

  return {
    errors,
    messages,
    isValid: messages.length === 0,
  };
};
